/*
 * 转换日期 转换格式可按照年月日时分秒配置 YYYY-MM-DD HH:mm:ss
 * formateDate('2019.11.11 11:11:20', 'YYYY-MM-DD HH:mm:ss'); //"2019-11-11 11:11:20"
 * formateDate('2019-11-11'); // 2019-11-11
 */
const formatDate = (date, template = 'YYYY-MM-DD', blankValue = '-') => {
  if (!date) {
    return blankValue;
  }
  const specs = 'YYYY:MM:DD:HH:mm:ss'.split(':');
  const timeStamp = new Date(date).getTime() - new Date().getTimezoneOffset() * 6e4;
  const res = new Date(timeStamp);
  return res
    .toISOString()
    .split(/[-:.TZ]/)
    .reduce((acc, item, i) => acc.split(specs[i]).join(item), template);
};
const formatDateTwo = (date, template = 'YYYY/MM/DD', blankValue = '/') => {
  if (!date) {
    return blankValue;
  }
  const specs = 'YYYY:MM:DD:HH:mm:ss'.split(':');
  const timeStamp = new Date(date).getTime() - new Date().getTimezoneOffset() * 6e4;
  const res = new Date(timeStamp);
  return res
    .toISOString()
    .split(/[-:.TZ]/)
    .reduce((acc, item, i) => acc.split(specs[i]).join(item), template);
};
const formatTime = (date, blankValue) => formatDate(date, 'YYYY-MM-DD HH:mm:ss', blankValue);
const formatToM = (date, blankValue) => formatDate(date, 'YYYY-MM-DD HH:mm', blankValue);
const formatToD = (date, blankValue) => formatDate(date, 'YYYY-MM-DD ', blankValue);
const formatHMS = (date, blankValue) => formatTime(date, blankValue).slice(-8);
export default {
  formatDate,
  formatTime,
  formatDateTwo,
  formatToM,
  formatToD,
  formatHMS,
};
